import { useMemo } from 'react';
import { CountryFlag } from 'shared/src/CountryFlag';
import { getCountryCode } from 'shared/src/getCountryCode';

import { virtualAccountLabel } from 'utils/helpers';

import { useVirtualAccounts } from 'hooks/context';

type InlineVirtualAccountProps = {
  accountNumber: string;
};

export const InlineVirtualAccount = ({
  accountNumber
}: InlineVirtualAccountProps) => {
  const { findAccountByAccountNumber } = useVirtualAccounts();

  const account = useMemo(
    () => findAccountByAccountNumber(accountNumber),
    [findAccountByAccountNumber, accountNumber]
  );

  return account ? (
    <div className="flex flex-row items-center gap-2">
      <CountryFlag
        className="!size-[22px]"
        countryCode={getCountryCode(account.currency_code)}
        svg
      />

      <p data-testid="account-label" className="truncate">
        {virtualAccountLabel(account)}
      </p>
    </div>
  ) : null;
};
